import { Module } from 'vuex'
import { RootState } from '@/store'
import { INotification } from '@/store/modules/ui/interfaces'
import { actions } from '@/store/modules/ui/actions'

export const storeModuleName:string = 'ui'

export interface UiState {
  notifications: INotification[]
  picturesInGallery: string[]
  currentGalleryPicture: number
  consultationModalStatus: boolean
  bookingOnlineModalStatus: boolean
  bookingOnlineModalId: string | number | null
  stateDutyModalStatus: boolean
}

const state: UiState = {
  notifications: [],
  picturesInGallery: [],
  currentGalleryPicture: 0,
  consultationModalStatus: false,
  bookingOnlineModalStatus: false,
  bookingOnlineModalId: null,
  stateDutyModalStatus: false
}

export const store: Module<UiState, RootState> = {
  state,
  getters: {
    notifications (state) {
      return state.notifications
    },
    picturesInGallery (state) {
      return state.picturesInGallery
    },
    currentGalleryPicture (state) {
      return state.currentGalleryPicture
    },
    consultationModalStatus (state) {
      return state.consultationModalStatus
    },
    bookingOnlineModalStatus (state) {
      return state.bookingOnlineModalStatus
    },
    bookingOnlineModalId (state) {
      return state.bookingOnlineModalId
    },
    stateDutyModalStatus (state) {
      return state.stateDutyModalStatus
    }
  },
  mutations: {
    setNotifications (state, value) {
      state.notifications = value
    },
    setPicturesInGallery (state, value) {
      state.picturesInGallery = value
    },
    setCurrentGalleryPicture (state, value) {
      state.currentGalleryPicture = value
    },
    setConsultationModalStatus (state, value) {
      state.consultationModalStatus = value
    },
    setBookingOnlineModalStatus (state, value) {
      state.bookingOnlineModalStatus = value
    },
    setBookingOnlineModalId (state, value) {
      state.bookingOnlineModalId = value
    },
    setStateDutyModalStatus (state, value) {
      state.stateDutyModalStatus = value
    }
  },
  actions,
  namespaced: true
}
